/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Rule_Non_AiInputs */

const en_directory_submit_rule_non_ai = /** @type {(inputs: Directory_Submit_Rule_Non_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit an AI product or an AI-powered service. General websites, studios, game sites, and unrelated services are not a fit.`)
};

const zh_directory_submit_rule_non_ai = /** @type {(inputs: Directory_Submit_Rule_Non_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请提交 AI 产品或使用 AI 能力的服务。普通网站、工作室、游戏站及无关服务不符合收录范围。`)
};

/**
* | output |
* | --- |
* | "Submit an AI product or an AI-powered service. General websites, studios, game sites, and unrelated services are not a fit." |
*
* @param {Directory_Submit_Rule_Non_AiInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_rule_non_ai = /** @type {((inputs?: Directory_Submit_Rule_Non_AiInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Rule_Non_AiInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_rule_non_ai(inputs)
	return zh_directory_submit_rule_non_ai(inputs)
});
export { directory_submit_rule_non_ai as "directory.submit.rule_non_ai" }